// extracted by mini-css-extract-plugin
export default {"btn_confirm":"ReminderPopup_btn_confirm__AGcKw","btn_delete":"ReminderPopup_btn_delete__HhZ4I"};